export default __webpack_public_path__ + "static/media/brand-threads.6dfec309.svg";